import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative grid min-h-[42rem] overflow-hidden border-b border-parchment/20 py-16 md:min-h-[50rem] md:grid-cols-12 md:items-end md:py-24">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          className="relative z-10 md:col-span-10"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[12ch] text-6xl md:text-8xl lg:text-[6rem]"
          tone="dark"
        />
        <div
          aria-hidden="true"
          className="absolute -right-32 top-0 h-full w-64 rounded-l-[100%] bg-plum md:right-[8%] md:w-[22rem]"
        />
        <div
          aria-hidden="true"
          className="absolute -right-52 top-0 h-full w-64 rounded-l-[100%] border-l border-thread bg-thread/10 md:-right-20 md:w-[24rem]"
        />
      </div>
    </VelvetSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
